import { PaymentGuidePage } from '~/features/taxdb/payment-guide-page'
import { useRoute } from '@features/app-hooks'
import { organizationModule } from '@features/organizations/organization-module'
import { PageNotFound } from '@features/organizations/pages/page-not-found'
import { STQuestionnaire } from '@features/st-questionnaire'
import {
  ClientOrganizerLoginPage,
  STQuestionnaireLookupPage
} from '@features/st-questionnaire-login'
import { ReactNode } from 'react'
import { useSelect } from '~/store'
import { CollectionHomePage } from './pages/collection-home-page'
import { OAuthLoginPage } from './pages/oauth-login-page'

/**
 * The app that the clients of accountants use to fill out a questionnaire.
 * It lives on its own domain and is whitelabeled, meaning it uses the branding of the accounants.
 *
 * They may send a link like organizer.tax/cpa-esq/taxes2021 to their clients.
 * When their clients, click the link, they'll have to login and then fill out what is essentially a survey.
 */
export function CollectionApp() {
  return (
    <OrganizationCollectionApp />
  )
}

function OrganizationCollectionApp() {
  const route = useRoute()

  switch (route.name) {
    case 'payment_guide':
      return <PaymentGuidePage />
    case '/':
      return <CollectionHomePage />
    case 'client_folder':
      return (
        <LoadOrganization>
          <ClientOrganizerLoginPage
            folderId={route.folderId}
          >
            <STQuestionnaire folderId={route.folderId} />
          </ClientOrganizerLoginPage>
        </LoadOrganization>
      )
    case 'client_folder_logged_out':
      return (
        <LoadOrganization>
          <ClientOrganizerLoginPage
            folderId={route.folderId}
          >
            <STQuestionnaire folderId={route.folderId} />
          </ClientOrganizerLoginPage>
        </LoadOrganization>
      )
    case 'oauth_callback':
      return <OAuthLoginPage provider={route.provider} code={route.code!} />
    case 'client_questionnaire':
    case 'client_questionnaire_legacy':
      return (
        <LoadOrganization>
          <STQuestionnaireLookupPage
            initialEmail={route.email}
          />
        </LoadOrganization>
      )
    default:
      return <PageNotFound />
  }
}

function LoadOrganization({
  children
}: {
  children: ReactNode
}) {
  const organization = useSelect('organization', (s) => s.organization)

  if (!organization) {
    return null
  }

  return <>{children}</>
}
